import type { CustomNode, CustomEdge } from '@src/components/custom-nodes/types';

export const getNodesBetween = (nodes: CustomNode[], edges: CustomEdge[], startNode: CustomNode, endNode: CustomNode) => {
  const nodesBetween: CustomNode[] = [];

  function findNodesBetween(currentNode: CustomNode) {
    const edgeWithCurrentNodeAsSource = edges.filter((edge) => edge.source === currentNode.id);
    const targetNodes = nodes.filter((node) => edgeWithCurrentNodeAsSource?.map(edge => edge.target).includes(node.id));

    targetNodes.forEach((targetNode) => {
      if (targetNode?.id === endNode.id) {
        return;
      } else if (targetNode) {
        nodesBetween.push(targetNode);
        return findNodesBetween(targetNode);
      }
    });
  }

  findNodesBetween(startNode);

  // return without duplicates
  return nodesBetween.filter((item, idx, allNodes) => !allNodes.slice(0, idx).map(item => item.id).includes(item.id));
}
